import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';
import { ModulePageHeader } from '~/components/ModulePageHeader/ModulePageHeader';

export const RiskCockpitHeader = () => {
  const { t } = useTranslation(I18nNamespace.riskSustainability, { keyPrefix: 'RiskCockpitHeader' });

  return <ModulePageHeader title={t('title')} />;
};
